// ✅ src/pages/StudentPage.js
import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import Header from '../components/Header';

function StudentPage() {
  const [assignedLectures, setAssignedLectures] = useState([]);
  const [watchHistory, setWatchHistory] = useState([]);
  const [selectedLecture, setSelectedLecture] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        await fetchAssignedLectures(uid);
        await fetchWatchHistory(uid);
      } else {
        alert("로그인이 필요합니다.");
      }
    });
    return () => unsubscribe();
  }, []);

  const fetchAssignedLectures = async (uid) => {
    const q = query(collection(db, 'lectureAssignments'), where('userId', '==', uid));
    const snapshot = await getDocs(q);
    const result = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        title: data.lectureTitle || data.lectureUrl?.split('/').pop() || '제목 없음',
        url: data.lectureUrl,
      };
    });
    setAssignedLectures(result);
  };

  const fetchWatchHistory = async (uid) => {
    const q = query(collection(db, 'histories'), where('userId', '==', uid));
    const snapshot = await getDocs(q);
    const result = snapshot.docs.map(doc => doc.data());
    setWatchHistory(result);
  };

  const hasWatched = (url) => {
    return watchHistory.some(h => h.lectureUrl === url);
  };

  return (
    <div style={{ maxWidth: '900px', margin: '40px auto', padding: '20px', fontFamily: 'sans-serif' }}>
      <Header role="student" />

      <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>🎓 학생 강의실</h1>

      <section style={{ marginBottom: '40px' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', borderBottom: '2px solid #ccc', paddingBottom: '8px' }}>📚 배정된 강의</h2>
        {assignedLectures.length === 0 ? (
          <p style={{ color: '#999' }}>아직 배정된 강의가 없습니다.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {assignedLectures.map((lec, idx) => (
              <div
                key={idx}
                onClick={() => setSelectedLecture(lec)}
                style={{
                  padding: '12px 16px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  backgroundColor: selectedLecture?.url === lec.url ? '#f0f8ff' : '#fafafa',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  transition: '0.2s',
                }}
              >
                <span style={{ fontWeight: 'bold' }}>📘 {lec.title}</span>
                {hasWatched(lec.url) && (
                  <span style={{ backgroundColor: '#28a745', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '0.8rem' }}>
                    시청 완료
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </section>

      {selectedLecture && (
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', borderBottom: '2px solid #ccc', paddingBottom: '8px' }}>
            🎬 {selectedLecture.title} 영상
          </h2>
          <video
            controls
            style={{ width: '100%', maxWidth: '800px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
            preload="auto"
            playsInline
          >
            <source src={selectedLecture.url} type="video/mp4" />
            현재 브라우저는 HTML5 video 태그를 지원하지 않습니다.
          </video>
        </section>
      )}

      <section>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', borderBottom: '2px solid #ccc', paddingBottom: '8px' }}>📜 내 수강 이력</h2>
        {watchHistory.length === 0 ? (
          <p style={{ color: '#999' }}>수강 이력이 없습니다.</p>
        ) : (
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
            {watchHistory.map((h, idx) => (
              <li key={idx}>
                📖 {h.lectureTitle || h.lectureUrl?.split('/').pop()} - {new Date(h.watchedAt).toLocaleString()}
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}

export default StudentPage;
